// apps/client/src/components/errors/Error403.tsx
import React from 'react';
import ErrorTemplate, { ErrorButtons } from './ErrorTemplate';

export const Error403: React.FC = () => {
  return (
    <ErrorTemplate
      title="403"
      heading="Access Forbidden"
      message="You don't have permission to access this resource. Contact your organisation admin if you believe this is an error."
      buttons={[ErrorButtons.HOME, ErrorButtons.BACK]}
    />
  );
};

export default Error403;
